export const getClientWidth = (): number => {
  return document.body.clientWidth || document.documentElement.clientWidth;
};
export const getClientHeight = (): number => {
  return (
    window.outerHeight || // ios 中的高度
    document.body.clientHeight ||
    document.documentElement.clientHeight
  );
};

/**
 * 检查浏览器是否支持某个css属性值
 * @param {String} key - 检查的属性值所属的css属性名
 * @param {String} value - 要检查的css属性值（不要带前缀）
 * @returns {String} - 返回浏览器支持的属性值
 */
export const validateCssValue = (key: string, value: string) => {
  var prefix = ["-o-", "-ms-", "-moz-", "-webkit-", ""];
  var prefixValue = [];
  for (var i = 0; i < prefix.length; i++) {
    prefixValue.push(prefix[i] + value);
  }
  var element = document.createElement("div");
  var eleStyle = element.style;
  for (var j = 0; j < prefixValue.length; j++) {
    eleStyle[key] = prefixValue[j];
  }
  return eleStyle[key];
};

/**
 * 添加当前域名前缀
 * @param routeUrl
 * @returns
 */
export const generateUrlByDomain = routeUrl => {
  return `${location.origin}${routeUrl}`;
};

/**
 * 是否是http开头，判断是否是 http URL
 * @param path
 */
export function isHttpPrefix(path: string | undefined | null) {
  return (path || "").indexOf("http") === 0;
}
